import { Directive } from '@angular/core';

@Directive({
  selector: '[appClickClose]'
})
export class ClickCloseDirective {

  constructor() { }

}
